var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full min-h-screen overflow-hidden"},[_c('div',{staticClass:"container gutters py-8 md:py-20 mx-auto"},[_c('nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }